import styled from 'styled-components';
import { CaptionRegularM, DefaultInput } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';
import ErrorMessageIcon from '@/assets/icons/errorMsgIcon.svg?react';

export const InputCont = styled.div`
  display: flex;
  flex-direction: column;
  height: 96px;
  position: relative;
`;

export const FormInput = styled(DefaultInput)`
  width: 320px;
  ${({ theme }: IThemeProvider) => `
      padding: ${theme.layout.spacing.mili};
  `}
`;

export const Label = styled.span`
  text-align: start;
`;

export const ErrorMsg = styled(CaptionRegularM)`
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.support.orange[100]};
      margin-left: ${theme.layout.spacing.nano};
  `}
`;

export const ErrorMsgCont = styled.div`
  display: flex;
  ${({ theme }: IThemeProvider) => `
      padding: ${theme.layout.spacing.nano} 0;
  `}
`;

export const ErrorMsgIcon = styled(ErrorMessageIcon)`
  width: 13px;
  height: 13px;
`;
